// removed by extract-text-webpack-plugin
module.exports = {"wrap":"src-components-PageWrap----PageWrap-module---wrap---2m8t8","nopadding":"src-components-PageWrap----PageWrap-module---nopadding---3jk0z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageWrap/PageWrap.module.scss
// module id = 1193
// module chunks = 168707334958949